// extracted by mini-css-extract-plugin
module.exports = {"chart-container":"CategoryChart_chart-container__1Z7yp","chart-title":"CategoryChart_chart-title__3-Sr8"};